import { render } from "./UIButton.vue?vue&type=template&id=6dbeafa1"
import script from "./UIButton.vue?vue&type=script&lang=js"
export * from "./UIButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__